import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';

interface NavigationGuardModalProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  onDiscard: () => void;
  isSaving: boolean;
}

const NavigationGuardModal: React.FC<NavigationGuardModalProps> = ({
  open,
  onClose,
  onSave,
  onDiscard,
  isSaving,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Unsaved Changes</DialogTitle>
      <DialogContent>
        <Typography>
          You have unsaved changes. Do you want to save before switching?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDiscard} color="error" disabled={isSaving}>
          Discard Changes
        </Button>
        <Button onClick={onClose} disabled={isSaving}>
          Cancel
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          color="primary"
          disabled={isSaving}
          startIcon={isSaving ? <CircularProgress size={16} /> : null}
        >
          {isSaving ? 'Saving...' : 'Save & Continue'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NavigationGuardModal;
